import { render, staticRenderFns } from "./TotpUserResetPasswordHandler.vue?vue&type=template&id=37cbeb36"
import script from "./TotpUserResetPasswordHandler.vue?vue&type=script&lang=ts"
export * from "./TotpUserResetPasswordHandler.vue?vue&type=script&lang=ts"
import style0 from "./TotpUserResetPasswordHandler.vue?vue&type=style&index=0&id=37cbeb36&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports